import {
  INICIA_CURSO,
  NOVO_CURSO,
  BUSCA_CURSO_EDICAO,
  CANCELA_EDICAO,
  INICIO_CURSO_SUCESSO,
  SALVA_CURSO_SUCESSO,
  REMOVE_CURSO_SUCESSO,
  BUSCA_CURSO_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  APLICA_FILTRO,
  LISTA_CURSO,
  LISTA_CURSO_SUCESSO,
  LIMPAR_CURSO,
  LISTA_CURSOS_POR_ESCOLA,
  LISTA_ANOS_LETIVOS_POR_CURSO_SUCESSO,
  LISTA_ESCOLAS_CURSO_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO_SUCESSO,
  APLICA_FILTRO_CURSO
} from "constants/ActionTypes";

const normalizeCursoListItem = (c) => {
  const id = c.id || c.Id || 0;
  const codigo = c.codigo || c.Codigo || c.id || c.Id || '';
  const nome = c.nome || c.Nome || '';
  const modalidade = c.modalidade || c.Modalidade || '';
  const cargaHoraria = c.cargaHoraria || c.CargaHoraria || c.carga_horaria || '';
  return { ...c, id, codigo, nome, modalidade, cargaHoraria };
};

const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Código', propriedadeApi: 'codigo', alinhamento: 'left' },
    { titulo: 'Nome do Curso', propriedadeApi: 'nome', alinhamento: 'left' },
    { titulo: 'Modalidade', propriedadeApi: 'modalidade', alinhamento: 'left' },
    { titulo: 'Carga Horária', propriedadeApi: 'cargaHoraria', alinhamento: 'left' }
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  cursoCarregado: null,

  // Campos do Formulario (mínimos)
  id: 0,
  codigo: '',
  nome: '',
  modalidade: '',
  cargaHoraria: '',
  descricao: '',
  qtdEtapas: 0,
  horaFalta: 0,
  nivelEnsinoId: null,
  tipoEnsinoId: null,
  tipoRegimeId: null,

  // Filtros
  nomeCursoFiltro: '',
  escolaFiltro: null,
  anoLetivoFiltro: '',
  listaEscolas: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_CURSO: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
      }
    }
    case NOVO_CURSO: {
      return {
        ...state,
        edicao: true,
        loader: false,
        id: 0,
        nome: '',
        modalidade: '',
        cargaHoraria: '',
        descricao: '',
        qtdEtapas: 0,
        horaFalta: 0,
        nivelEnsinoId: null,
        tipoEnsinoId: null,
        tipoRegimeId: null,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case BUSCA_CURSO_EDICAO: {
      return {
        ...state,
        loader: true
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
      }
    }
    case INICIO_CURSO_SUCESSO: {
      const retorno = action.payload || [];
      const lista = Array.isArray(retorno) ? retorno : (retorno && (retorno.curso || retorno.Curso) ? (retorno.curso || retorno.Curso) : []);
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: lista,
      }
    }
    case SALVA_CURSO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case REMOVE_CURSO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_CURSO: {
      return {
        ...state,
        loader: true,
        carregandoLista: true,
      }
    }
    case LISTA_CURSOS_POR_ESCOLA: {
      return {
        ...state,
        loader: true,
        carregandoLista: true,
        listGrid: [],
        listGridComFiltro: []
      }
    }
    case APLICA_FILTRO_CURSO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case LISTA_CURSO_SUCESSO: {
      const retorno = action.payload;
      const lista = Array.isArray(retorno) ? retorno : (retorno && (retorno.curso || retorno.Curso) ? (retorno.curso || retorno.Curso) : []);
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeCursoListItem) : [];
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: listaNorm,
        listGridComFiltro: listaNorm,
      }
    }
    case LISTA_ESCOLAS_CURSO_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id, title: e.nome || e.Nome }))
        : [];
      return { ...state, listaEscolas };
    }

    case LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO_SUCESSO: {
      const anosRaw = action.payload || [];
      const listaAnosLetivos = Array.isArray(anosRaw)
        ? anosRaw.map(a => (typeof a === 'object' ? { id: a.ano || a.Ano || a.id, title: (a.ano || a.Ano || a.title || '').toString() } : { id: a, title: a.toString() }))
        : [];
      return { ...state, listaAnosLetivos };
    }

    case LISTA_ANOS_LETIVOS_POR_CURSO_SUCESSO: {
      return {
        ...state,
        listaAnosLetivos: action.payload
      }
    }

    case LIMPAR_CURSO: {
      return {
        ...state,
        nomeCursoFiltro: '',
        textoFiltro: '',
        escolaFiltroCurso: null,
        anoLetivoFiltroCurso: ''
      }
    }
    case BUSCA_CURSO_EDICAO_SUCESSO: {
      var retorno = action.payload;
      var base = retorno && retorno.curso ? retorno.curso : retorno;
      return {
        ...state,
        edicao: true,
        loader: false,
        cursoCarregado: base,
        id: base.id || base.Id || 0,
        nome: base.nome || base.Nome || '',
        modalidade: base.modalidade || base.Modalidade || '',
        cargaHoraria: base.cargaHoraria || base.CargaHoraria || '',
        descricao: base.descricao || base.Descricao || '',
        // O backend pode retornar "quantidadeEtapas" e "horaFaltaMin"
        qtdEtapas: base.quantidadeEtapas || base.qtdEtapas || base.qtd_etapas || base.QtdEtapas || 0,
        horaFalta: base.horaFaltaMin || base.horaFalta || base.hora_falta || base.HoraFaltaMin || base.HoraFalta || 0,
        nivelEnsinoId: base.nivelEnsinoId || base.nivel_ensino_id || base.NivelEnsinoId || null,
        tipoEnsinoId: base.tipoEnsinoId || base.tipo_ensino_id || base.TipoEnsinoId || null,
        tipoRegimeId: base.tipoRegimeId || base.tipo_regime_id || base.TipoRegimeId || null,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false,
        carregandoLista: false,
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
        carregandoLista: false,
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false,
        carregandoLista: false,
      }
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: state.edicao,
        carregandoLista: false,
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false,
        carregandoLista: false,
      }
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case ALTERACAO_COMBO: {
      // Para manter compatibilidade com os selects, persiste sempre o ID primitivo quando disponível
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      return {
        ...state,
        [action.payload.nomeCombo]: valorNormalizado,
      }
    }
    case ALTERACAO_CHECK: {
      var retorno = action.payload;
      return {
        ...state,
        [retorno.name]: retorno.value
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }
    default:
      return state;
  }
}